<template>
    <div class="d-flex flex-wrap date-range justify-space-between pb-2">
        <div class="d-flex flex-wrap justify-space-between">
            <div class="d-flex flex-wrap">
                <label class="align-self-center">
                    From
                </label>

                <div class="d-flex flex-wrap justify-center">
                    <v-select
                        class="date-select pr-2 pl-2"
                        :items="getDayOptions(dateRange.from)"
                        label="Day"
                        item-text="text"
                        item-value="value"
                        hide-details
                        density="compact"
                        v-model="dateRange.from.day"
                        menu-props="auto"
                        @input="handleDateRangeFromChange(dateRange)"
                        />
                    
                    <v-select
                        class="date-select pr-2 pl-2"
                        :items="getMonthOptions(dateRange.from.year)"
                        label="Month"
                        item-text="text"
                        item-value="value"
                        hide-details
                        density="compact"
                        v-model="dateRange.from.month"
                        menu-props="auto"
                        @input="handleDateRangeFromChange(dateRange)"
                        />
        
                    <v-select
                        class="date-select pr-2 pl-2"
                        :items="yearOptions"
                        label="Year"
                        item-text="text"
                        item-value="value"
                        hide-details
                        density="compact"
                        v-model="dateRange.from.year"
                        menu-props="auto"
                        @input="handleDateRangeFromChange(dateRange)"
                        />
                </div>
            </div>
            
            <div class="d-flex flex-wrap">
                <label class="align-self-center">
                    To
                </label>

                <div class="d-flex flex-wrap justify-center">
                    <v-select
                        class="date-select pr-2 pl-2"
                        :items="getDayOptions(dateRange.to)"
                        label="Day"
                        item-text="text"
                        item-value="value"
                        hide-details
                        density="compact"
                        v-model="dateRange.to.day"
                        menu-props="auto"
                        @input="handleDateRangeToChange(dateRange)"
                    />
                    
                    <v-select
                        class="date-select pr-2 pl-2"
                        :items="getMonthOptions(dateRange.to.year)"
                        label="Month"
                        item-text="text"
                        item-value="value"
                        hide-details
                        density="compact"
                        v-model="dateRange.to.month"
                        menu-props="auto"
                        @input="handleDateRangeToChange(dateRange)"
                    />
                
                    <v-select
                        class="date-select pr-2 pl-2"
                        :items="yearOptions"
                        label="Year"
                        item-text="text"
                        item-value="value"
                        hide-details
                        density="compact"
                        v-model="dateRange.to.year"
                        menu-props="auto"
                        @input="handleDateRangeToChange(dateRange)"
                    />
                </div>
            </div>
        </div>

        <div class="d-flex flex-wrap justify-center">
            <v-btn @click="addDateRange(index)" class="lime mt-2 ml-2"><v-icon>add</v-icon></v-btn>
            <v-btn @click="removeDateRange(index)" class="red mt-2 ml-2"><v-icon>remove</v-icon></v-btn>
        </div>    
    </div>
</template>

<script>
/**
* A Vue component representing a single date range for the batch loader
*
*/

export default {
    name: 'hotel-batch-loader-date-range',
    props: ['index', 'dateRange'],
    data () {
        return {
            monthOptions: [
            { text: 'Jan', value: 1 },
            { text: 'Feb', value: 2 },
            { text: 'Mar', value: 3 },
            { text: 'Apr', value: 4 },
            { text: 'May', value: 5 },
            { text: 'Jun', value: 6 },
            { text: 'Jul', value: 7 },
            { text: 'Aug', value: 8 },
            { text: 'Sep', value: 9 },
            { text: 'Oct', value: 10},
            { text: 'Nov', value: 11},
            { text: 'Dec', value: 12},
        ],

        now: new Date(),
        }
    },

    methods: {
        getDayOptions(date){
            let daysInMonth = new Date(date.year, date.month, 0).getDate();

            let options = Array.from({length: daysInMonth}, (v, k) => ({ text: (k+1).toString(), value: k+1 }));

            if(date.year != this.now.getFullYear() || date.month != this.now.getMonth() + 1){
                return options;
            }

            return options.filter(option => option.value >= this.now.getDate());
        },

        getMonthOptions(year){
            if(year != this.now.getFullYear()){
                return this.monthOptions;
            }

            let validMonths = [];
            
            this.monthOptions.forEach(month => {
                if(month.value >= this.now.getMonth() + 1){
                    validMonths.push(month);
                }
            })

            return validMonths;
        },

        addDateRange(index){
            this.$emit('add-date-range', index);
        },

        removeDateRange(index){
            this.$emit('remove-date-range', index);
        },

        updateDateRange(dateRange){
            this.$emit('update-date-range', dateRange);
        },

        handleDateRangeFromChange(dateRange){
            let newDateRange = this.cleanDateRangeArray(dateRange);
            newDateRange.index = this.index;
            
            this.$emit('update-date-range', newDateRange);
        },

        cleanDateRangeArray(dateRange){
            dateRange.from = this.cleanDateArray(dateRange.from);
            dateRange.to = this.cleanDateArray(dateRange.to);

            let fromDate = new Date(dateRange.from.year, dateRange.from.month - 1, dateRange.from.day);
            let toDate = new Date(dateRange.to.year, dateRange.to.month - 1, dateRange.to.day);
            
            if(fromDate > toDate){
                toDate = new Date(dateRange.from.year, dateRange.from.month - 1, dateRange.from.day);
                toDate.setDate(toDate.getDate() + 1);
            }

            return {
                from: {
                    day: fromDate.getDate(),
                    month: fromDate.getMonth() + 1,
                    year: fromDate.getFullYear()
                },
                to: {
                    day: toDate.getDate(),
                    month: toDate.getMonth() + 1,
                    year: toDate.getFullYear()
                }
            };
        },

        cleanDateArray(dateArray){
            let month = new Date(dateArray.year, dateArray.month, 0);

            if (dateArray.day > month.getDate()) {
                dateArray.day = month.getDate();
            }

            let date = new Date(dateArray.year, dateArray.month - 1, dateArray.day);

            if (date < this.now) {
                dateArray.year = this.now.getFullYear();
                dateArray.month = this.now.getMonth() + 1;
                dateArray.day = this.now.getDate();
            }

            return dateArray;
        },
        
        handleDateRangeToChange(dateRange){
            let fromDate = new Date(dateRange.from.year, dateRange.from.month - 1, dateRange.from.day);
            let toDate = new Date(dateRange.to.year, dateRange.to.month - 1, dateRange.to.day);
            
            if(fromDate > toDate){
                fromDate = new Date(dateRange.to.year, dateRange.to.month - 1, dateRange.to.day);
                fromDate.setDate(fromDate.getDate() - 1);
            }

            let newDateRange = {
                index: this.index,
                from: {
                    day: fromDate.getDate(),
                    month: fromDate.getMonth() + 1,
                    year: fromDate.getFullYear()
                },
                to: {
                    day: toDate.getDate(),
                    month: toDate.getMonth() + 1,
                    year: toDate.getFullYear()
                }
            };

            this.$emit('update-date-range', newDateRange);
        }
    },

    /**
     * Once mounted this component needs to load all available models
     */
    mounted() {
    },

    computed: {

        yearOptions(){
            let dateCounter = new Date();
            dateCounter.setFullYear(dateCounter.getFullYear());

            let yearOptions = [];

            for(var i = 0; i < 5; i++){
                let year = dateCounter.getFullYear();
                yearOptions.push({ text: year, value: year });
                dateCounter.setFullYear(dateCounter.getFullYear() + 1);
            }

            return yearOptions;
        },
    },

    watch: 
        {
    }
}
</script>

<style>
    .date-range div {
        background-color: #F2F2F2;
    }

    .date-select {
        max-width: 100px;
    }

    .date-range button {
        max-width: 40px;
        min-width: 20px;
    }


</style>
